<template>
  <div class="field">
    <label class="item-label"></label>
    <a href="#" @click="$parent.info[slg]=''" class="top-right-align eraseimg">Erase Image</a>
    <div style="text-align:center;" class="obj-field upload-wrapper">
      <input
        @change="fileUpload($event)"
        accept="image/*"
        fileUpload
        type="file"
        value="Upload Image"
      />
      <div v-if="!$parent.info[slg]" style="height:125px;"></div>
      <img v-if="$parent.info[slg]" id :src="image" height="125" alt class="wfimage" />
      <progress v-show="loading"></progress>
      <p v-show="!loading" class="dz-message">Upload Files Here</p>
    </div>
  </div>
</template>

<script>
import { scrypt } from "crypto";
import { Script } from "vm";
export default {
  name: "ImageRef",
  props: ["slg", "fname"],
  data() {
    return {
      loading: false
    };
  },
  methods: {
    fileUpload(e) {
      var file = e.target.files[0];
      var storageRef = window.fs.ref(
        `${this.$parent.$parent.set.siteName}/${file.name}`
      );
      var uploader = storageRef.put(file);

      uploader.on(
        "state_changed",
        statusSnapshot => {
          this.loading = true;
        },
        err => {
          alert("error", err);
        },
        () => {
          uploader.snapshot.ref.getDownloadURL().then(downloadURL => {
            wfToken
              ? this.$emit("input", downloadURL)
              : this.$emit("input", { url: downloadURL });
            this.loading = false;
          });
        }
      );
    }
  },
  computed: {
    image() {
      if (this.$parent.info[this.slg]) {
        if (this.$parent.info[this.slg].url) {
          return this.$parent.info[this.slg].url;
        } else {
          return this.$parent.info[this.slg];
        }
      } else return "";
    }
  }
};
</script>

<style scoped>
.eraseimg {
  color: red;
  margin-top: -23px;
  font-size: 15px;
}
</style>